import DatasetsExportView from "./datasets-export.html";


angular.module("datasets")
    .factory("datasetsService", ['$injector', function ($injector) {
        var instance = null;
        function remove() {
            instance = null;
        }
        var service = {
            export: function (id, options) {
                if (instance != null) return;
                var $uibModal = $injector.get("$uibModal");
                instance = $uibModal.open({
                    animation: true,
                    template: DatasetsExportView,
                    controller: 'DatasetsExportCtrl',
                    size: 'md',
                    resolve: {
                        id: function () { return id; },
                        type: function () { return null; },
                        options: function () { return options; }
                    }
                });
                instance.result.then(function (result) {
                    remove();
                }, function () {
                    remove();
                })
            },
            exportByType: function (type, options) {
                if (instance != null) return;
                var $uibModal = $injector.get("$uibModal");
                instance = $uibModal.open({
                    animation: true,
                    template: DatasetsExportView,
                    controller: 'DatasetsExportCtrl',
                    size: 'md',
                    resolve: {
                        id: function () { return null; },
                        type: function () { return type; },
                        options: function () { return options; }
                    }
                });
                instance.result.then(function (result) {
                    remove();
                }, function () {
                    remove();
                })
            },
        };
        return service;
    }]);